const warnings = Object.freeze({
  EMAIL_INPUT: 'Please check the format of your email address',
  CONTACT_THE_OFFICE: 'Please contact the office on 0330 113 0330',
  PASSWORD_FORMAT: 'Problem with password format, please try again',
  EMAIL_OR_PASSWORD: "Please check you've entered an email and password",
});

export default warnings;
